import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-personalloans-v2-form.component.scss';
var CalculatorPersonalloansV2Form = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorPersonalloansV2Form, _super);
    function CalculatorPersonalloansV2Form(element) {
        return _super.call(this, element) || this;
    }
    CalculatorPersonalloansV2Form.prototype.init = function () { };
    CalculatorPersonalloansV2Form.prototype.bindEvents = function () { };
    return CalculatorPersonalloansV2Form;
}(Base));
export { CalculatorPersonalloansV2Form };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculator-personalloans-v2-form/calculator-personalloans-v2-form.component.ts
// module id = 799
// module chunks = 0